document.addEventListener('DOMContentLoaded', function() {
	const videoFeeds = document.querySelectorAll('.video-feed .swiper');
	const videoFeedNext = document.querySelectorAll('.video-swiper-next');
	const videoFeedPrev = document.querySelectorAll('.video-swiper-prev');
  
	if (videoFeeds.length > 0) {
	  // Loop through each video feed and initialize Swiper
	  for (let i = 0; i < videoFeeds.length; i++) {
		// Add dynamic class
		videoFeeds[i].classList.add('swiper-' + i);
		videoFeedNext[i]?.classList.add('video-swiper-next-' + i);
		videoFeedPrev[i]?.classList.add('video-swiper-prev-' + i);
  
		// Initialize Swiper
		const initvideoFeed = new Swiper('.video-feed .swiper-' + i, {
		  simulateTouch: false,
		  grabCursor: false,
		  slidesPerView: 1.5,
		  spaceBetween: 24,
		  centeredSlides: true,
		  navigation: {
			nextEl: '.video-swiper-next-' + i,
			prevEl: '.video-swiper-prev-' + i,
		  },
		  breakpoints: {
			320: {
			  slidesPerView: 1.5,
			  centeredSlides: true,
			},
			576: {
			  slidesPerView: 2.5,
			  centeredSlides: false,
			},
			768: {
			  slidesPerView: 3.5,
			  centeredSlides: false,
			},
			992: {
			  slidesPerView: 4.5,
			  centeredSlides: false,
			}
		  }
		});
	  }
	}
  
  // Function to set arrow height based on video ratio
  function setArrowHeight() {
    // Find all video-feed blocks
    const videoFeedBlocks = document.querySelectorAll('.video-feed');

    videoFeedBlocks.forEach(block => {
      // Find the first .card--video element within the current block
      const cardVideo = block.querySelector('.card--video');
      
      if (cardVideo) {
        // Find the .ratio.ratio-16x9 element within the card
        const ratioDiv = cardVideo.querySelector('.ratio.ratio-16x9');
        
        if (ratioDiv) {
          // Get the height of the ratio div and add 5 pixels
          const height = ratioDiv.offsetHeight + 5;

          // Find the arrow elements within the current block
          const nextArrow = block.querySelector('.swiper-arrow.swiper-arrow--next');
          const prevArrow = block.querySelector('.swiper-arrow.swiper-arrow--prev');

          // Set the height of the arrows
          if (nextArrow) nextArrow.style.height = `${height}px`;
          if (prevArrow) prevArrow.style.height = `${height}px`;
        }
      }
    });
  }
  
	// Call the function initially
	setArrowHeight();
  
	// Add event listener for window resize to adjust arrow height
	window.addEventListener('resize', setArrowHeight);
  });